export const GLOBAL_BUSINESS_VARIABLES = {
  totalStockAvailable: {
    defaultValue: '12',
    stringValueWithM: '12M',
    numberValue: 12,
    numberValueExtended: '12.000.000',
  },
};
